var _path, _path2, _rect, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 7.3C3.75 6.90832 3.75103 6.67481 3.76951 6.50424C3.78038 6.4039 3.79421 6.3628 3.79934 6.35088C3.81391 6.33128 3.83128 6.31391 3.85088 6.29934C3.8628 6.29421 3.9039 6.28038 4.00424 6.26951C4.17481 6.25103 4.40832 6.25 4.8 6.25H19.2C19.5917 6.25 19.8252 6.25103 19.9958 6.26951C20.0961 6.28038 20.1372 6.29421 20.1491 6.29934C20.1687 6.31391 20.1861 6.33127 20.2007 6.35088C20.2058 6.36279 20.2196 6.4039 20.2305 6.50424C20.249 6.67481 20.25 6.90832 20.25 7.3V20.7C20.25 21.0917 20.249 21.3252 20.2305 21.4958C20.2196 21.5961 20.2058 21.6372 20.2007 21.6491C20.1861 21.6687 20.1687 21.6861 20.1491 21.7007C20.1372 21.7058 20.0961 21.7196 19.9958 21.7305C19.8252 21.749 19.5917 21.75 19.2 21.75H4.8C4.40832 21.75 4.1748 21.749 4.00424 21.7305C3.9039 21.7196 3.86279 21.7058 3.85088 21.7007C3.83128 21.6861 3.81391 21.6687 3.79934 21.6491C3.79421 21.6372 3.78038 21.5961 3.76951 21.4958C3.75103 21.3252 3.75 21.0917 3.75 20.7V7.3ZM3.80138 6.34693C3.80143 6.34706 3.80086 6.34834 3.79954 6.35042C3.80067 6.34785 3.80133 6.34681 3.80138 6.34693ZM3.84693 6.30138C3.84681 6.30133 3.84785 6.30067 3.85042 6.29954C3.84834 6.30086 3.84706 6.30143 3.84693 6.30138ZM20.1531 6.30138C20.1529 6.30143 20.1517 6.30087 20.1496 6.29955C20.1521 6.30067 20.1532 6.30133 20.1531 6.30138ZM20.1986 6.34693C20.1987 6.34681 20.1993 6.34785 20.2005 6.35042C20.1991 6.34834 20.1986 6.34706 20.1986 6.34693ZM20.1986 21.6531C20.1986 21.653 20.1991 21.6517 20.2004 21.6496C20.1993 21.6521 20.1987 21.6532 20.1986 21.6531ZM20.1531 21.6986C20.1532 21.6986 20.1522 21.6993 20.1496 21.7005C20.1516 21.6992 20.1529 21.6986 20.1531 21.6986ZM3.84693 21.6986C3.84706 21.6986 3.84834 21.6991 3.85042 21.7005C3.84785 21.6993 3.84681 21.6987 3.84693 21.6986ZM3.79954 21.6496C3.80086 21.6517 3.80143 21.6529 3.80138 21.6531C3.80133 21.6532 3.80067 21.6521 3.79954 21.6496Z",
    stroke: "#95959D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 4.5L4 4.5C4 4.03406 4 3.80109 4.07612 3.61732C4.17761 3.37229 4.37229 3.17761 4.61732 3.07612C4.80109 3 5.03406 3 5.5 3L18.5 3C18.9659 3 19.1989 3 19.3827 3.07612C19.6277 3.17761 19.8224 3.37229 19.9239 3.61732C20 3.80109 20 4.03406 20 4.5Z",
    fill: "#95959D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 9.5,
    width: 4,
    height: 3,
    stroke: "#95959D",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15.5H18",
    stroke: "#95959D",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 9.5H18",
    stroke: "#95959D",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12.5H18",
    stroke: "#95959D",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18.5H18",
    stroke: "#95959D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.412a75ffbc017a7504bab67d0371bd37.svg";
export { ForwardRef as ReactComponent };